import type { MutableState, Tools } from 'final-form';

import type { FormData } from '../types';

const setFieldValue = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [name, value]: [name: string, value: any],
  state: MutableState<FormData>,
  { changeValue }: Tools<FormData>
) => {
  changeValue(state, name, () => value);
};

const clearFieldValue = (
  [name]: [name: string],
  state: MutableState<FormData>,
  { changeValue }: Tools<FormData>
) => {
  changeValue(state, name, () => undefined);
};

const removeField = (
  [name]: [name: string],
  state: MutableState<FormData>,
  { changeValue, resetFieldState }: Tools<FormData>
) => {
  if (state.formState.submitErrors?.[name]) {
    delete state.formState.submitErrors[name];
  }

  resetFieldState(name);
  changeValue(state, name, () => undefined);
};

export const betSlipMutators = { setFieldValue, clearFieldValue, removeField };

export type BetSlipMutators = {
  [Property in keyof typeof betSlipMutators]: (
    ...args: Parameters<(typeof betSlipMutators)[Property]>[0]
  ) => void;
};
